/**
 * GENERATED from EPN.PayrollConfig.Api/Infrastructure/TaxPaymentSettings/StateTaxProgramRegistry.json (the draft 44-state candidate list).
 * Development and test data for the mock gateway only; the server owns the real registry. DRAFT, NOT APPROVED tax configuration.
 */
export interface DraftProgram { key: string; name: string; kind: 'employer_rate' | 'withholding_setup' | 'conditional_or_special' | 'deposit_schedule'; applicability: string }
export interface DraftState { code: string; name: string; noGeneralWageIncomeTax: boolean; programs: DraftProgram[] }

export const DRAFT_STATE_REGISTRY: DraftState[] = [
  {
    "code": "AK",
    "name": "Alaska",
    "noGeneralWageIncomeTax": true,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "ui_ee",
        "name": "Employee UI Contribution",
        "kind": "conditional_or_special",
        "applicability": "Alaska has employee UI contributions in addition to employer UI; verify split and wage base."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "AL",
    "name": "Alabama",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "local",
        "name": "Local Occupational Tax",
        "kind": "conditional_or_special",
        "applicability": "Municipality-specific occupational taxes, where applicable; verify locality and nexus."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "AR",
    "name": "Arkansas",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "CO",
    "name": "Colorado",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "famli",
        "name": "FAMLI",
        "kind": "conditional_or_special",
        "applicability": "State paid family/medical leave premium and employer-size split."
      },
      {
        "key": "local",
        "name": "Local Occupational Privilege Tax",
        "kind": "conditional_or_special",
        "applicability": "Conditional by city/work location."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "CT",
    "name": "Connecticut",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "pfml",
        "name": "CT Paid Leave",
        "kind": "conditional_or_special",
        "applicability": "Employee paid leave contributions, exemptions and quarterly remittance."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "DE",
    "name": "Delaware",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "pfml",
        "name": "Delaware Paid Leave",
        "kind": "conditional_or_special",
        "applicability": "2026 benefit year; employer size/coverage category and private-plan exceptions."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "GA",
    "name": "Georgia",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "HI",
    "name": "Hawaii",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "tdi",
        "name": "Temporary Disability Insurance",
        "kind": "conditional_or_special",
        "applicability": "Insured/self-insured employer coverage; permitted employee premium deduction depends on coverage."
      },
      {
        "key": "benefits",
        "name": "Prepaid Health Care",
        "kind": "conditional_or_special",
        "applicability": "Employer health coverage compliance is separate from payroll tax rate setup; optional linked compliance item."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "IA",
    "name": "Iowa",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "ID",
    "name": "Idaho",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "IL",
    "name": "Illinois",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "IN",
    "name": "Indiana",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "local",
        "name": "County Income Tax",
        "kind": "conditional_or_special",
        "applicability": "Employee residence-based county rate/codes; verify agency sourcing."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "KS",
    "name": "Kansas",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "KY",
    "name": "Kentucky",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "local",
        "name": "Local Occupational Tax",
        "kind": "conditional_or_special",
        "applicability": "City/county occupational withholding as applicable."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "LA",
    "name": "Louisiana",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "MA",
    "name": "Massachusetts",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "pfml",
        "name": "Paid Family and Medical Leave",
        "kind": "conditional_or_special",
        "applicability": "Employee and employer premiums and employer-size thresholds."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "MD",
    "name": "Maryland",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "local",
        "name": "County Income Tax",
        "kind": "conditional_or_special",
        "applicability": "Local income tax withholding by resident county and applicable agency rules."
      },
      {
        "key": "future",
        "name": "Family and Medical Leave Insurance — future",
        "kind": "conditional_or_special",
        "applicability": "Future program; no 2026 automatic current payroll deductions without agency confirmation."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "ME",
    "name": "Maine",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "pfml",
        "name": "Paid Family and Medical Leave",
        "kind": "conditional_or_special",
        "applicability": "Premium collections/benefit schedule vary by effective rules; verify program phase."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "MI",
    "name": "Michigan",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "local",
        "name": "Municipal Income Tax",
        "kind": "conditional_or_special",
        "applicability": "Conditional in cities levying municipal income tax; resident/worksite distinctions."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "MN",
    "name": "Minnesota",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "pfml",
        "name": "Minnesota Paid Leave",
        "kind": "conditional_or_special",
        "applicability": "2026 employer and employee Paid Leave premium, wage base and size logic."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "MO",
    "name": "Missouri",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "local",
        "name": "City Earnings Tax",
        "kind": "conditional_or_special",
        "applicability": "Local city earnings tax where applicable (e.g., selected cities), confirm locality."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "MS",
    "name": "Mississippi",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "MT",
    "name": "Montana",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "NC",
    "name": "North Carolina",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "ND",
    "name": "North Dakota",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "NE",
    "name": "Nebraska",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "NH",
    "name": "New Hampshire",
    "noGeneralWageIncomeTax": true,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "NJ",
    "name": "New Jersey",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "tdi",
        "name": "Temporary Disability Insurance",
        "kind": "conditional_or_special",
        "applicability": "Employer and worker disability contributions."
      },
      {
        "key": "pfml",
        "name": "Family Leave Insurance",
        "kind": "conditional_or_special",
        "applicability": "Worker contributions and annual wage cap."
      },
      {
        "key": "workforce",
        "name": "Workforce Development / Supplemental Workforce",
        "kind": "conditional_or_special",
        "applicability": "Employer/worker program contributions as applicable."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "NM",
    "name": "New Mexico",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "OH",
    "name": "Ohio",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "local",
        "name": "School District Withholding",
        "kind": "conditional_or_special",
        "applicability": "Resident school-district tax if applicable."
      },
      {
        "key": "local2",
        "name": "Municipal Income Tax",
        "kind": "conditional_or_special",
        "applicability": "Municipality-based withholding and workplace/residence sourcing."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "OK",
    "name": "Oklahoma",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "OR",
    "name": "Oregon",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "pfml",
        "name": "Paid Leave Oregon",
        "kind": "conditional_or_special",
        "applicability": "Employee/employer premium and approved equivalent plan status."
      },
      {
        "key": "transit",
        "name": "Statewide Transit Tax",
        "kind": "conditional_or_special",
        "applicability": "Employee statewide transit withholding."
      },
      {
        "key": "transit2",
        "name": "TriMet / Lane Transit",
        "kind": "conditional_or_special",
        "applicability": "Local employer transit payroll taxes by exact service boundary."
      },
      {
        "key": "wbf",
        "name": "Workers Benefit Fund",
        "kind": "conditional_or_special",
        "applicability": "Workers Benefit Fund assessment; hours worked and employer/employee allocation."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "PA",
    "name": "Pennsylvania",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "local",
        "name": "Local Earned Income Tax",
        "kind": "conditional_or_special",
        "applicability": "PSD code, residence/work location, collector and withholding locality."
      },
      {
        "key": "local2",
        "name": "Local Services Tax",
        "kind": "conditional_or_special",
        "applicability": "Applicable municipality/school district local services tax."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "RI",
    "name": "Rhode Island",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "tdi",
        "name": "TDI / TCI",
        "kind": "conditional_or_special",
        "applicability": "Employee TDI deductions funding disability/caregiver benefits."
      },
      {
        "key": "workforce",
        "name": "Job Development Fund",
        "kind": "conditional_or_special",
        "applicability": "Employer job development assessment as applicable."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "SC",
    "name": "South Carolina",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "SD",
    "name": "South Dakota",
    "noGeneralWageIncomeTax": true,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "TN",
    "name": "Tennessee",
    "noGeneralWageIncomeTax": true,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "UT",
    "name": "Utah",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "VA",
    "name": "Virginia",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "future",
        "name": "Family/Medical Leave — future review",
        "kind": "conditional_or_special",
        "applicability": "Future program status/implementation requires agency verification before active payroll configuration."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "VT",
    "name": "Vermont",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "optin",
        "name": "Voluntary Family/Medical Leave Insurance",
        "kind": "conditional_or_special",
        "applicability": "Opt-in employer offering: not universally mandatory payroll withholding."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "WA",
    "name": "Washington",
    "noGeneralWageIncomeTax": true,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "pfml",
        "name": "Paid Family and Medical Leave",
        "kind": "conditional_or_special",
        "applicability": "Employee/employer premiums and business size threshold."
      },
      {
        "key": "ltc",
        "name": "WA Cares Fund",
        "kind": "conditional_or_special",
        "applicability": "Employee premium and exemption proof; no state wage income tax withholding."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "WI",
    "name": "Wisconsin",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "WV",
    "name": "West Virginia",
    "noGeneralWageIncomeTax": false,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "wht",
        "name": "State Income Tax Withholding",
        "kind": "withholding_setup",
        "applicability": "Employee tax elections/agency tables; do not treat as generic flat manual rate."
      },
      {
        "key": "local",
        "name": "Local Service Fee",
        "kind": "conditional_or_special",
        "applicability": "Some municipal service fees may apply; verify specific jurisdiction and worker eligibility."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  },
  {
    "code": "WY",
    "name": "Wyoming",
    "noGeneralWageIncomeTax": true,
    "programs": [
      {
        "key": "ui",
        "name": "State Unemployment Insurance",
        "kind": "employer_rate",
        "applicability": "Determine from employer registration and work localization; experience rate and wage base are agency-driven."
      },
      {
        "key": "payment",
        "name": "Tax Deposit / Filing Schedule",
        "kind": "deposit_schedule",
        "applicability": "Schedule by agency/account/threshold, NOT employer pay frequency. Separate component per obligation."
      }
    ]
  }
];
